<template>
  <v-chart v-if="ready" :options="graph"/>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/treemap'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

export default {
  name: 'tree-map-cost',
  components: {'v-chart': ECharts},
  props: ['data'],
  data() {
    return {
      ready: false,
      graph : {
        tooltip: {
          show: true,
          formatter: function (p) {
            const formatNumber = (value) => {
              if (value === null || value === undefined || value === '') return '';
              const num = Number(value);
              if (Number.isNaN(num)) return value;

              const isInt = Number.isInteger(num);
              return new Intl.NumberFormat('es-AR', {
                minimumFractionDigits: isInt ? 0 : 1,
                maximumFractionDigits: isInt ? 0 : 1,
              }).format(num);
            };

            const name = p?.name ?? '';
            const raw = p?.value ?? p?.data?.value;
            return `${name}: ${formatNumber(raw)} <em>USD/ha</em>`;
          }
        },
        title : {
          text: 'Costos Comerciales',
          x:'left',
          top:5,
          padding:0
        },
        grid: {
          top:0
        },
        textStyle: {
          fontFamily: 'Gotham',
          color: '#888'
        },
        legend: {
          show: true,
          data:['Flete', 'Acondicionamiento', 'Otros']
        },
        series: [{
          type: 'treemap',
          width: '100%',
          height: '88%',
          levels: [{},
            {
              itemStyle: {
                borderWidth: 2,
                borderColor: '#ddd'
              }
            }],

          upperLabel: {
            show:true,
            padding:3,
            fontWeight: 'bold',
            color: '#002'
          },
          itemStyle: {
            color:'red'
          },
          breadcrum: {
            show: true
          },
          data: [{
            name: 'Flete (USD/Ha)',            // First tree
            value: function() {
              const n = (v) => {
                const num = Number(v);
                return Number.isNaN(num) ? 0 : num;
              };
              return n(this.data['com_flete_corto']) + n(this.data['com_flete_largo']);
            },
            label: {
              show: true,
            },
            children: [{
              name: 'Flete corto',       // First leaf of first tree
              value: Number(this.data['com_flete_corto']) || 0
            }, {
              name: 'Flete largo',       // Second leaf of first tree
              value: Number(this.data['com_flete_largo']) || 0
            }]
          },
          {
            name: 'Acondicionamiento (USD/Ha)',            // Second tree
            value: function() {
              const n = (v) => {
                const num = Number(v);
                return Number.isNaN(num) ? 0 : num;
              };
              return (
                n(this.data['com_acon_sec']) +
                n(this.data['com_acon_zar']) +
                n(this.data['com_acon_mer']) +
                n(this.data['com_acon_cal']) +
                n(this.data['com_acon_otros'])
              );
            },
            children: [{
              name: 'Secada',       // First leaf of first tree
              value: Number(this.data['com_acon_sec']) || 0
            }, {
              name: 'Zaranda',       // Second leaf of first tree
              value: Number(this.data['com_acon_zar']) || 0
            },{
              name: 'Merma',       // Second leaf of first tree
              value: Number(this.data['com_acon_mer']) || 0
            },
            {
              name: 'Calidad',       // Second leaf of first tree
              value: Number(this.data['com_acon_cal']) || 0
            },

            {
              name: 'Otros',       // Second leaf of first tree
              value: Number(this.data['com_acon_otros']) || 0
            }]
          },
          {
            name: 'Otros (USD/Ha)',            // Second tree
            value: function() {
              const n = (v) => {
                const num = Number(v);
                return Number.isNaN(num) ? 0 : num;
              };
              return n(this.data['com_otro_com']) + n(this.data['com_otro_par']) + n(this.data['com_otro_alm']);
            },
            children: [{
              name: 'Comisión',       // First leaf of first tree
              value: Number(this.data['com_otro_com']) || 0
            }, {
              name: 'Paritaria',       // Second leaf of first tree
              value: Number(this.data['com_otro_par']) || 0
            },
            {
              name: 'Almacenamiento',       // Second leaf of first tree
              value: Number(this.data['com_otro_alm']) || 0
            }]
          }]
        }]
      }

    }
  },
  mounted() {
    this.$nextTick(function() {
      this.ready = true;
    })

  }
}
</script>
